import React from "react";
import image10 from "../../image/10.png";
import image12 from "../../image/12.png";
import image14 from "../../image/14.jpg";
import theblowup from "../../image/1.png";
import image3 from "../../image/3.png";

const OfferSection = () => {
  return (
    <section className="w-full bg-slate-50/50 py-20 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
      {/* Decorative Ambient Background Soft Glows */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-orange-100/50 rounded-full blur-[140px] pointer-events-none"></div>

      <div className="max-w-7xl mx-auto relative z-10">

        {/* Section Header */}
        <div className="text-center max-w-2xl mx-auto mb-16 space-y-3">
          <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold tracking-wider uppercase bg-orange-100 text-orange-700">
            Infrastructure Showcase
          </span>
          <h2 className="text-3xl sm:text-4xl font-black text-slate-900 tracking-tight">
            Advanced Manufacturing & Facility
          </h2>
          <p className="text-slate-600 text-sm sm:text-base">
            Inside our state-of-the-art production facility delivering precision-engineered piping networks.
          </p>
        </div>

        {/* Floating Gallery Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 items-center">

          {/* Left Column Stack */}
          <div className="space-y-6 flex flex-col items-center md:items-stretch">
            <div data-aos="fade-up" className="group rounded-2xl overflow-hidden shadow-xl shadow-slate-200/60 border border-slate-200/80 bg-white max-w-sm w-full relative">
              <div className="overflow-hidden h-52">
                <img
                  src={image14}
                  alt="Factory Stack"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-3 bg-white border-t border-slate-100 flex items-center justify-between">
                <span className="text-xs font-bold text-slate-800">Finished Goods Stockyard</span>
                <span className="text-[10px] text-orange-600 font-semibold uppercase">Polo Pipes</span>
              </div>
            </div>

            <div data-aos="fade-up" data-aos-delay="100" className="group rounded-2xl overflow-hidden shadow-xl shadow-slate-200/60 border border-slate-200/80 bg-white max-w-sm w-full md:translate-x-4 relative">
              <div className="overflow-hidden h-52">
                <img
                  src={image12}
                  alt="Pipes Extrusion"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-3 bg-white border-t border-slate-100 flex items-center justify-between">
                <span className="text-xs font-bold text-slate-800">Pipe Threading & Post-Processing Unit</span>
                <span className="text-[10px] text-orange-600 font-semibold uppercase">Polo Pipes</span>
              </div>
            </div>
          </div>

          {/* Center Column Featured Highlight */}
          <div data-aos="fade-up" data-aos-delay="200" className="flex justify-center">
            <div className="group rounded-3xl overflow-hidden shadow-2xl shadow-orange-500/10 border-2 border-orange-500/20 bg-white max-w-md w-full relative p-2">
              <div className="relative rounded-2xl overflow-hidden h-72 md:h-96">
                <img
                  src={theblowup}
                  alt="Piping Materials"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-950/80 via-transparent to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4 text-white">
                  <span className="px-2.5 py-1 bg-orange-500 text-[10px] font-bold rounded-full uppercase tracking-wider mb-2 inline-block">
                    Featured Asset
                  </span>
                  <h3 className="text-lg font-bold">High-Grade Polymer Stock</h3>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column Stack */}
          <div className="space-y-6 flex flex-col items-center md:items-stretch">
            <div data-aos="fade-up" data-aos-delay="300" className="group rounded-2xl overflow-hidden shadow-xl shadow-slate-200/60 border border-slate-200/80 bg-white max-w-sm w-full md:-translate-x-4 relative">
              <div className="overflow-hidden h-52">
                <img
                  src={image3}
                  alt="Inventory View"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-3 bg-white border-t border-slate-100 flex items-center justify-between">
                <span className="text-xs font-bold text-slate-800">Advanced Machinery</span>
                <span className="text-[10px] text-orange-600 font-semibold uppercase">Polo Pipes</span>
              </div>
            </div>

            <div data-aos="fade-up" data-aos-delay="400" className="group rounded-2xl overflow-hidden shadow-xl shadow-slate-200/60 border border-slate-200/80 bg-white max-w-sm w-full relative">
              <div className="overflow-hidden h-52">
                <img
                  src={image10}
                  alt="Product Packaging"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-3 bg-white border-t border-slate-100 flex items-center justify-between">
                <span className="text-xs font-bold text-slate-800">Pipe Extrusion Line</span>
                <span className="text-[10px] text-orange-600 font-semibold uppercase">Polo Pipes</span>
              </div>
            </div>
          </div>

        </div>

      </div>
    </section>
  );
};

export default OfferSection;